var React = require('react');

function Katakana (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.98 20.03L31.49 25 15.44 93.21 0 89.58l15.98-69.55zM57 40.07l-15.22 4.16 9.62 35.64 16.96-2.77L57 40.07zM44.06 0h11l-1.1 28.62h-9.9V0zM61.1 0h11L71 28.62h-9.9V0zm42.52 45.96h49.6v14.01h-49.6zm76.16 0h52.54v14.01h-52.54zm94.62-28.88l16 2.46-10.09 69.13-16.71-3.52 10.8-68.07zm27.5 3.15h13.74v34.52l23.76-7.11 5.19 11.77L301.42 74a1 1 0 01-1.39-1zm75.16-5.57v75.4h17.77V57.59a.2.2 0 01.28-.18l21.06 6.92 5.61-14.24-26.55-8.88-.34-26.34z","fill":"#062e4b","data-name":"レイヤー 2"}));
}

Katakana.defaultProps = {"viewBox":"0 0 421.81 93.21"};

module.exports = Katakana;

Katakana.default = Katakana;
